var React = require('react');

function ReplicaSet (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_11960_6569)","key":0},[React.createElement("path",{"d":"M6.31149 2.40234L12.623 8.71382L6.31149 15.0253L1.68468e-05 8.71382L6.31149 2.40234Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M16 8.71341L9.68919 15.0252L8.72476 14.0608L14.0722 8.71341L8.72476 3.36602L9.68919 2.40259L16 8.71341Z","fill":"currentColor","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_11960_6569"},React.createElement("rect",{"width":"16","height":"16","fill":"white","transform":"translate(0 0.713867)"})))]);
}

ReplicaSet.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = ReplicaSet;

ReplicaSet.default = ReplicaSet;
